module.exports = __webpack_public_path__ + "static/media/gocode.5eb2c3a2.jpg";